module.exports = __webpack_public_path__ + "img/handling.9fe1fa06.svg";